// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-cls1__c7a9cef0f8110f3cbe9a{/*!*/}.styles-cls2___f610ed2d2e6d5800d1d{width:24px;height:24px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "styles-cls1__c7a9cef0f8110f3cbe9a",
	"cls2": "styles-cls2___f610ed2d2e6d5800d1d styles-cls1__c7a9cef0f8110f3cbe9a"
};
export default ___CSS_LOADER_EXPORT___;
